const customerEn = {
    purchase: require('lang/en/customer/Purchase').default,
    sessions: require('lang/en/customer/Sessions').default,
    ticket: require('lang/en/customer/Ticket').default,
    recharge: require('lang/en/customer/Recharge').default,
    password: require('lang/en/customer/Password').default,
};

export default customerEn;
